import { Injectable, EventEmitter } from '@angular/core';
import { ApiService } from './api.service';
import { Tag } from '../models/tag.model';
import { TagCategory } from '../models/tag-category.model';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class TagService {

    constructor(
        private dataService: ApiService
    ) {}

    tagNodeName: string = 'TAG';

    public savedTags: Array<number> = [];
    public populatedTagCategories: Array<TagCategory> = new Array<TagCategory>();
    public hitMaxSelectedTags: boolean = false;
    public savedTagsURL:string = "http://" + window.location.host + "/saved/";
    public tagUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();

    // this function is used for the "save" tags url
    setSelectedTagCategories(tagArray: Array<number>): Promise<any> {
        return this.dataService.getData().then(res => {

            this.populateTagCategories(res);

            // loop through populated tagCategories
            this.populatedTagCategories.forEach((tagCat, index, array) => {      
                          
                // loop through tags in each category
                tagCat.tags.forEach((tag, index, array) => {     
                    
                    // loop through array of selected tags from url, and set matching tags to selected
                    tagArray.forEach((tagItem) => {
                        if(tagItem == tag.id){
                            tag.selected = true;
                            tagCat.tagSelectedCount++;
                        }
                    });
                });
            });
        });        
    }

    toggleTooltip(tagPassed: Tag): void{
         this.populatedTagCategories.forEach((tagCat, index, array) => {     
                // loop through tags in each category
                tagCat.tags.forEach((tag, index, array) => {     
                    if(tagPassed == tag){
                        tag.tooltipOpen = !tag.tooltipOpen;
                    } else{
                        tag.tooltipOpen = false;
                    }
                });
         });
    }

    populateTagCategories(res): Array<TagCategory> {
        if(!this.populatedTagCategories.length){
            let tagArray = new Array<Tag>();
            var seen = new Set;   

            // create tag categories
            res[this.tagNodeName].filter(
                (item, index) => {
                    if (!seen.has(item.Category)) {
                        let tagCat = new TagCategory();
                        tagCat.title = item.Category;
                        tagCat.tagSelectedCount = 0;
                        tagCat.id = index;
                        this.populatedTagCategories.push(tagCat);
                        seen.add(item.Category);
                        return true;
                    }
                }
            );

            // create tags
            res[this.tagNodeName].forEach((tagItem, j, array) => {
                let tag = new Tag();
                tag.category = tagItem.Category;
                tag.title = tagItem.Tag;
                let regex = /[^\s][\/][^\s]/;
                if(regex.test(tag.title)){
                    tag.title = tag.title.replace("/", " / ");
                }
                tag.id = Number(tagItem.aaapkTagID);
                tag.selected = false;
                tag.image = tagItem.TagImageFilename;
                tag.tooltip = tagItem.TagDescription;
                tagArray.push(tag);
            });

            // push tags into matching tag categories
            this.populatedTagCategories.forEach((tagCatObj, i) => {
                tagArray.forEach((tagObj, j) => {
                    if(tagObj.category == tagCatObj.title){
                        tagCatObj.tags.push(tagObj);
                    }
                });
            });

            // set first category selected by default, for tabs
            this.populatedTagCategories[0].tabSelected = true;
        }

        //console.log('this.populatedTagCategories',this.populatedTagCategories);
        return this.populatedTagCategories;
    }

    updateSavedTags(tag:Tag): void{
        if(tag.selected){
            this.savedTags.push(tag.id);
        } else{
            let tagIDIndex = this.savedTags.indexOf(tag.id);
            this.savedTags.splice(tagIDIndex,1);
        }

        if(this.savedTags.length == 8){
            this.hitMaxSelectedTags = true;
        } else{
            this.hitMaxSelectedTags = false;
        }        
    }

    emitTagUpdated(exceedMax: boolean): void{
        this.tagUpdated.emit(exceedMax);
    }

    updateTagSelectedCount(tag:Tag): void{
        let matchedTagCat = this.populatedTagCategories.find(el => el.title == tag.category);

        if(tag.selected){
            matchedTagCat.tagSelectedCount++;
        } else{
            matchedTagCat.tagSelectedCount--;
        }
    }
}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/services/tag.service.ts